import "./NeutralToggle.css";

/**
 * NeutralToggle Component
 *
 * @param {boolean} isOn - Toggle state (true = on, false = off)
 * @param {function} onToggle - Callback function when toggle is clicked
 * @param {boolean} disabled - Whether the toggle is disabled
 * @param {string} titlePosition - Position of the title: "left-right" (shows different text on each side), "top" (shows combined text on top)
 * @param {string} titleOff - Text to display when toggle is off (used for "left-right" mode or combined with titleOn for "top" mode)
 * @param {string} titleOn - Text to display when toggle is on (used for "left-right" mode or combined with titleOff for "top" mode)
 */
function NeutralToggle({
  isOn = false,
  onToggle,
  disabled = false,
  titlePosition = "top",
  titleOff = null,
  titleOn = null,
}) {
  const handleClick = () => {
    if (onToggle && !disabled) {
      onToggle(!isOn);
    }
  };

  const renderToggleSwitch = () => (
    <div
      className={`App-neutral-toggle-switch ${
        disabled ? "App-neutral-toggle-switch-disabled" : ""
      }`}
      onClick={handleClick}
    >
      <span
        className={
          isOn
            ? "App-neutral-toggle-switch-on"
            : "App-neutral-toggle-switch-off"
        }
      />
    </div>
  );

  if (titlePosition === "left-right" && (titleOff || titleOn)) {
    return (
      <div className="App-neutral-toggle-container-horizontal">
        <span
          className={`App-neutral-toggle-label-left ${
            !isOn ? "App-neutral-toggle-label-active" : ""
          }`}
        >
          {titleOff}
        </span>
        {renderToggleSwitch()}
        <span
          className={`App-neutral-toggle-label-right ${
            isOn ? "App-neutral-toggle-label-active" : ""
          }`}
        >
          {titleOn}
        </span>
      </div>
    );
  }

  // Default: top position
  return (
    <div className="App-neutral-toggle-container-vertical">
      {titleOff || titleOn ? (
        <span className="App-neutral-toggle-label-top">
          {`${titleOff || ""}${titleOff && titleOn ? " / " : ""}${
            titleOn || ""
          }`}
        </span>
      ) : null}
      {renderToggleSwitch()}
    </div>
  );
}

export default NeutralToggle;
